<div
    class="absolute inset-0 flex flex-col min-w-0 overflow-y-auto"
    cdkScrollable
>
    <!-- Header -->
    <div
        class="flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between sm:pt-4 sm:pb-16 sm:px-10 bg-default dark:bg-transparent"
    >
        <div class="flex-1 min-w-0">
            <!-- Breadcrumbs -->
            <div>
                <div class="flex-wrap items-center hidden font-medium sm:flex">
                    <div>
                        <a
                            class="whitespace-nowrap text-primary-500"
                            [routerLink]="BaseRoute"
                            >{{ data?.parentTitle | transloco }}</a
                        >
                    </div>
                    <div class="flex items-center ml-1 whitespace-nowrap">
                        <mat-icon
                            class="icon-size-5 text-secondary"
                            [svgIcon]="
                                override.isRTL
                                    ? 'heroicons_solid:chevron-left'
                                    : 'heroicons_solid:chevron-right'
                            "
                        ></mat-icon>
                        <span class="ml-1">{{
                            data?.title?.plural | transloco
                        }}</span>
                    </div>
                </div>
                <div class="flex sm:hidden">
                    <a
                        class="inline-flex items-center -ml-1.5 text-secondary font-medium"
                        [routerLink]="'./..'"
                    >
                        <mat-icon
                            class="icon-size-5 text-secondary"
                            [svgIcon]="
                                !override.isRTL
                                    ? 'heroicons_solid:chevron-left'
                                    : 'heroicons_solid:chevron-right'
                            "
                        ></mat-icon>
                        <span class="ml-1">{{ "Back" | transloco }}</span>
                    </a>
                </div>
            </div>
            <!-- Title -->
            <div class="mt-2">
                <h2
                    class="text-3xl font-extrabold leading-7 tracking-tight truncate md:text-4xl sm:leading-10"
                    *ngIf="!data?.isLocalization"
                >
                    {{ (isEdit ? "Update" : "Add") | transloco }}
                    {{ data?.title?.single | transloco }}
                </h2>
                <h2
                    class="text-3xl font-extrabold leading-7 tracking-tight truncate md:text-4xl sm:leading-10"
                    *ngIf="data?.isLocalization"
                >
                    {{ "Add" | transloco }}
                    {{ data?.title?.single | transloco }}
                </h2>
            </div>
        </div>
        <!-- Actions -->
        <div class="flex items-center mt-6 shrink-0 sm:mt-0 sm:ml-4">
            <button
                mat-stroked-button
                *ngIf="data?.viewAll"
                [routerLink]="data?.route"
                routerLinkActive="router-link-active"
            >
                <mat-icon
                    class="mr-2 icon-size-5"
                    svgIcon="mat_outline:list"
                ></mat-icon>
                {{ "View" | transloco }} {{ data?.title.plural | transloco }}
            </button>
            <button
                class="ml-3"
                mat-flat-button
                [color]="'primary'"
                (click)="cancel()"
            >
                <mat-icon
                    class="mr-2 icon-size-5"
                    svgIcon="mat_outline:cancel"
                ></mat-icon>
                {{ "Cancel" | transloco }}
            </button>
            <button
                class="ml-3"
                mat-flat-button
                [ngClass]="{ 'bg-green-500': !data?.form?.invalid }"
                *ngIf="data?.add"
                (click)="save()"
                [disabled]="data?.form?.invalid"
            >
                <mat-icon
                    class="mr-2 icon-size-5"
                    svgIcon="mat_outline:save"
                ></mat-icon>
                {{ "Save" | transloco }}
            </button>
        </div>
    </div>

    <!-- Main -->
    <div class="flex-auto p-6 -mt-16 shadow sm:p-10 rounded-t-2xl bg-card">
        <ng-content select="[form]"></ng-content>
    </div>
</div>
